<script setup lang="ts">
const { state } = useBottomFix()
</script>

<template>
  <div id="bottomFix" v-show="state.isVisible"></div>
</template>
